import axiosHttpRequest from "../axios"

async function userLogoutDetails(endpoint, postedData, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postedData,
    configheaders
  );
  return serviceResponse;
}

async function resetLogin(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    queryparams,
    configheaders
  );
  return serviceResponse;
}

export default {
  userLogoutDetails,
  resetLogin
};



